import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useParams, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { I18nProvider } from "./i18n";
import { CartProvider } from "./context/CartContext";
import { AgeGate } from "./components/AgeGate";
import { CookieBanner } from "./components/CookieBanner";
import { InstallPrompt } from "./components/InstallPrompt";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import CitySelect from "./pages/CitySelect";
import VendorList from "./pages/VendorList";
import Storefront from "./pages/Storefront";
import Checkout from "./pages/Checkout";
import Recruitment from "./pages/Recruitment";
import OrderSent from "./pages/OrderSent";
import TrackOrder from "./pages/TrackOrder";
import Legal from "./pages/Legal";
import CityLanding from "./pages/CityLanding";
import ClubStuff from "./pages/ClubStuff";
import Contact from "./pages/Contact";
import { BlogList, BlogPost } from "./pages/Blog";
import Loyalty from "./pages/Loyalty";
import Login from "./pages/Login";
import Register from "./pages/Register";
import VendorDashboard from "./pages/VendorDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import NotFound from "./pages/NotFound";
import ProductPage from "./pages/ProductPage";
import { CityProvider } from "./context/CityContext";

// Ancienne URL de catégorie (VOID) → nouvelle (Puffs CBD). Redirection permanente côté client (SPA).
function RedirectSlug({ to }) {
  const { slug } = useParams();
  return <Navigate to={`/${to}/${slug}`} replace />;
}
import { SeoProvider } from "./context/SeoContext";
import { track, getSid } from "./lib/analytics";
import { CityModal } from "./components/CityModal";

function SeoCanonical() {
  const { pathname } = useLocation();
  useEffect(() => {
    let path = pathname.replace(/\/+$/, "");
    if (!path) path = "/";
    const url = `${window.location.origin}${path}`;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
    const og = document.querySelector('meta[property="og:url"]');
    if (og) og.setAttribute("content", url);
  }, [pathname]);
  return null;
}

function GaPageView() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", { page_path: pathname, page_location: window.location.href, page_title: document.title });
    }
  }, [pathname]);
  return null;
}

function StuffAnalytics() {
  const { pathname } = useLocation();
  useEffect(() => { track("pageview"); }, [pathname]);
  return null;
}

function Layout({ children }) {
  const { pathname } = useLocation();
  const hideFooter = pathname.startsWith("/vendeur") || pathname.startsWith("/admin");
  return (
    <div className="min-h-screen flex flex-col bg-ink grain">
      <Navbar />
      <main className="flex-1 relative z-10">{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <I18nProvider>
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <CityProvider>
          <SeoProvider>
          <SeoCanonical />
          <GaPageView />
          <StuffAnalytics />
          <AgeGate />
          <CityModal />
          <Toaster position="top-center" theme="dark" />
          <Layout>
            <Routes>
              <Route path="/" element={<CitySelect />} />
              <Route path="/ville/:city" element={<VendorList />} />
              <Route path="/livraison-cbd/:slug" element={<CityLanding />} />
              <Route path="/club" element={<ClubStuff />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/boutique/:vendorId" element={<Storefront />} />
              <Route path="/panier" element={<Checkout />} />
              <Route path="/commande-envoyee" element={<OrderSent />} />
              <Route path="/suivi/:ref" element={<TrackOrder />} />
              <Route path="/recrutement" element={<Recruitment />} />
              <Route path="/fidelite" element={<Loyalty />} />
              <Route path="/mentions-legales" element={<Legal page="mentions" />} />
              <Route path="/cgv" element={<Legal page="cgv" />} />
              <Route path="/confidentialite" element={<Legal page="confidentialite" />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/vendeur" element={<VendorDashboard />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/fleurs/:slug" element={<ProductPage />} />
              <Route path="/resines/:slug" element={<ProductPage />} />
              <Route path="/puffs/:slug" element={<ProductPage />} />
              <Route path="/void/:slug" element={<RedirectSlug to="puffs" />} />
              <Route path="/void" element={<Navigate to="/" replace />} />
              <Route path="/chicha/:slug" element={<ProductPage />} />
              <Route path="/produit/:slug" element={<ProductPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
          <CookieBanner />
          <InstallPrompt />
          </SeoProvider>
          </CityProvider>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
    </I18nProvider>
  );
}

export default App;
